export default {"src":"/_next/static/media/mastercard.5ecddf25.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};